import {FC} from 'react'
import { useField, useFormikContext, getIn } from 'formik';

interface FormSpanProps {
    name: string;    
}

const FormSpan: FC<FormSpanProps> = ({ name }) => {
    const [field] = useField(name);
    return (
        <span>{field.value}</span>
    );
};

const Step3: FC = () => {
    const formikProps = useFormikContext()
    const companyOverseas = getIn(formikProps.values, 'companyOverseas');

    return (
    <div className='w-800px d-flex flex-column justify-content-start align-items-stretch'>
        <div className='pb-8 pb-lg-10'>
            <h2 className='fw-bolder text-dark'>Confirm your account</h2>
        </div>
        <div>
            <h3 className='fw-bolder text-dark'>Company Details</h3>
            <div className="separator my-2"></div>            
            <div className='fv-row row gy-5'>
                <div className="col-5 text-end">
                    <span>Company Name</span>
                </div>
                <div className="col">
                    <FormSpan name='companyName' />                    
                </div>            
            </div>
            { companyOverseas ? (
            <div className='fv-row row gy-5'>
                <div className="col-5 text-end">                                
                </div>
                <div className="col">
                    <span>(overseas company)</span>        
                </div>
            </div>    
            ) : (
            <div className='fv-row row gy-5'>
                <div className="col-5 text-end">            
                    <span>Company UEN</span>        
                </div>
                <div className="col">
                    <FormSpan name='companyRegistration' />                    
                </div>
            </div>
            )}
            
            <div className='fv-row row gy-5'>
                <div className="col-5 text-end">            
                    <span>Address</span>        
                </div>
                <div className="col">
                    <FormSpan name='companyAddress' />                    
                </div>
            </div>
            <div className='fv-row row gy-5'>
                <div className="col-5 text-end">            
                    <span>Telephone</span>        
                </div>
                <div className="col">
                    <FormSpan name='companyTelephone' />                    
                </div>
            </div>
            <div className='fv-row row gy-5'>
                <div className="col-5 text-end">            
                    <span>Fax</span>        
                </div>
                <div className="col">
                    <FormSpan name='companyFax' />                    
                </div>
            </div>
            <div className='fv-row row gy-5'>
                <div className="col-5 text-end">            
                    <span>Website</span>        
                </div>
                <div className="col">
                    <FormSpan name='companyWebsite' />                    
                </div>
            </div>
        </div>
        <div>
            <h3 className='fw-bolder text-dark'>Management Info</h3>
            <div className="separator my-2"></div>
            <div className='fv-row row gy-5'>
                <div className="col-5 text-end">
                    <span>Name</span>
                </div>
                <div className="col">
                    <FormSpan name='adminName' />                    
                </div>            
            </div>
            <div className='fv-row row gy-5'>
                <div className="col-5 text-end">
                    <span>Designation</span>
                </div>
                <div className="col">
                    <FormSpan name='adminDesignation' />                    
                </div>            
            </div>
            <div className='fv-row row gy-5'>
                <div className="col-5 text-end">
                    <span>Contact</span>
                </div>
                <div className="col">
                    <FormSpan name='adminContact' />                    
                </div>            
            </div>
            <div className='fv-row row gy-5'>
                <div className="col-5 text-end">
                    <span>Email</span>
                </div>
                <div className="col">
                    <FormSpan name='adminEmail' />                    
                </div>            
            </div>            
        </div>
    </div>
    )
}

export {Step3}
